import { costLine, formatUsd } from '../lib/usageStats.js';
import { useI18n } from '../i18n/LanguageProvider.js';

/**
 * One line giving the estimated cost of a result or a project, or "not priced"
 * when no price was known: never a zero that would read as free.
 */
export function CostLine({ cost }: { cost: { costUsd?: number | null; priceKnown?: boolean } }) {
  const { t } = useI18n();
  const line = costLine(cost);
  if (!line || line.kind === 'none') return null;

  const text =
    line.kind === 'unpriced'
      ? t('studio.cost.unpriced')
      : t(line.kind === 'partial' ? 'studio.cost.partial' : 'studio.cost.estimated', {
          cost: formatUsd(line.costUsd),
        });
  return <p className="muted tiny studio-cost">{text}</p>;
}
